import { localStorageService } from './local-storage.service';

const USER_SECRET_STORAGE_KEY = 'user';

/**
 * Get current secret.
 * @returns {string | null}
 */
function getCurrentSecret() {
  return localStorageService.get(USER_SECRET_STORAGE_KEY);
}

/**
 * Saves a secret.
 * @param {string} secret Secret to save.
 */
function saveSecret(secret) {
  localStorageService.save(USER_SECRET_STORAGE_KEY, secret);
}

/** Removes current secret. */
function removeSecret() {
  localStorageService.remove(USER_SECRET_STORAGE_KEY);
}

export const userSecretStorageService = {
  getCurrentSecret,
  saveSecret,
  removeSecret,
};
